export default "__VITE_ASSET__C0jEXr6B__"